import { PositionsWidget as RichPositionsWidget } from "~/v3-poc/features/positions";

export interface PositionsWidgetConnectorProps {
  id: string;
}

/**
 * Workspace adapter — maps widget id into the rich Positions feature package.
 */
export const PositionsWidget = ({ id }: PositionsWidgetConnectorProps) => (
  <RichPositionsWidget id={id} />
);
